import React, { useEffect, useState } from "react";
import Banner from "~/assets/images/banner.png";
import "./SliderBanner.scss";
import Slider from "react-slick";
import { useDispatch, useSelector } from "react-redux";
import { getBanner } from "~/services/BannerService";

const settings = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 2000,
  arrows: false,
};

function SliderBanner() {
  const banners = useSelector((state) => {
    return state.banner.banner.banners;
  });
  const dispath = useDispatch();
  const [listBanner, setListBanner] = useState([]);
  useEffect(() => {
    getBanner(dispath);
    setListBanner(banners);
    // eslint-disable-next-line
  }, []);

  return (
    <div>
      <Slider className="slider-banner" {...settings}>
        {!listBanner.length ? (
          <div className="banner-item">
            <img src={Banner} alt="" />
          </div>
        ) : (
          listBanner.map((item, index) => {
            return (
              <div className="banner-item" key={index}>
                <a href={item.linkTo}>
                  <img src={item.image} alt={item.description} />
                </a>
              </div>
            );
          })
        )}
      </Slider>
    </div>
  );
}

export default SliderBanner;
